import axios from 'axios';

axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// Create a Newsletter Subscription
const createNewsletter = async (newsletter) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/crms?source=Newsletter`,
    {
      email: newsletter.email,
      firstName: newsletter.firstName,
      lastName: newsletter.lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Page-Route': window.location.pathname,
        'X-Page-Title': document.title,
      },
    }
  );

  console.log(response);

  return response;
};

export default {
  createNewsletter,
};
